import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
import { NavigationActionToggle } from '../../NavigationActionToggle/NavigationActionToggle';
/**
 * Navigation action toggle login container
 */
export const navigationActionToggleLoginContainerStyles = ({ theme }) => css `
	cursor: pointer;

	@media ((min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) and (max-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.xxxl)})) {
		font-size: 0;
		gap: 0;
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		&:hover {
			background-color: unset;
			color: ${theme.colors.highlight.textInteractiveOnLight};
		}

		&:focus {
			background-color: unset;
			color: unset;
		}

		&:active {
			color: ${theme.colors.action.textActive};
		}
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: -${theme.borderWidth.m}px;
	}
`;
export const NavigationActionToggleLoginContainer = styled(NavigationActionToggle) `
	${navigationActionToggleLoginContainerStyles}
`;
/**
 * Navigation action toggle login container status-text
 */
export const navigationActionToggleLoginContainerStatusTextStyles = () => css `
	display: none;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.md)}) {
		display: block;
	}
`;
export const NavigationActionToggleLoginContainerStatusText = styled.span `
	${navigationActionToggleLoginContainerStatusTextStyles}
`;
